import * as React from 'react'
import { Collapse } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { get } from 'redux/nauta/actions'
import { nauta } from 'api'
import { toast } from 'react-toastify'
import Nixi1Spinner from 'components/Nixi1Spinner'

const PluginNauta = (props) => {
  const { isRemoveByUser } = props.user
  const [open, setOpen] = React.useState(false)
  const nautaButtons = useSelector(store => store.nauta.buttons)
  const [processes, setProcesses] = React.useState([])
  const dispatch = useDispatch()

  React.useEffect(()=> {
    dispatch(get())
  }, [])

  React.useEffect(()=> {
    buttons()
  }, [nautaButtons])

  const toggle = () => {
    setOpen(isRemoveByUser ? false : !open)
  }

  const buttons = () => {
    const _nautaButtons = (nautaButtons || []).map((it)=> ({ ...it, isSubmitting: 'false' }))
    const _processes = [
      // {label: I18n.t('processes_save_time'), _id: 'updateIdentification', updateIdentification: 1, isSubmitting: 'false'}
    ].concat(_nautaButtons)
    setProcesses(_processes)
  }

  const onClick = (process) => {
    const data = process.updateIdentification === 1
      ? { userId: props.user.id, action: process._id, updateIdentification: process.updateIdentification }
      : { userId: props.user.id, action: process._id }

    setProcesses(processes.map((it)=> it._id === process._id ? ({ ...it, isSubmitting: 'true' }) : it))
    nauta.launchProcess(data).then(result => {
      if (result.data.success) {
        setProcesses(processes.map((it)=> it._id === process._id ? ({ ...it, isSubmitting: 'false' }) : it))
      }
      else {
        setProcesses(processes.map((it)=> it._id === process._id ? ({ ...it, isSubmitting: 'error' }) : it))
      }
    }).catch(error =>{
      console.log(error)
      toast(I18n.t('error_not_start_nauta_process_while_running'), { autoClose: 5000 })
      setProcesses(processes.map((it)=> it._id === process._id ? ({ ...it, isSubmitting: 'error' }) : it))
      setTimeout(() => {
        setProcesses(processes => processes.map((it)=> it._id === process._id ? ({ ...it, isSubmitting: 'false' }) : it))
      }, 5000)

    })
  }

  return (
    <div className={`plugin-nauta-card ${isRemoveByUser ? 'disabled' : ''}`}>
      <div className='title-container'>
        <div className='title'>
          <i className={'nav-icon-nauta'} />
          {I18n.t('processes_automated')}
        </div>
        <div className='action-buttons-container'>
          <i className={`fa fa-chevron-${open ? 'up' : 'down'}`} onClick={toggle} />
        </div>
      </div>

      <Collapse isOpen={open} className='plugin-nauta-inner'>
        <div className='separator' />
        <div className='buttons-container'>
          {
            processes.map((it) =>
              (
                <div key={it._id}>
                  <div className={`nauta-button ${it._id} ${it.isSubmitting}`} type='button' onClick={()=>onClick(it)}>
                    {it.isSubmitting === 'true'
                      ? <Nixi1Spinner height='20px' width='20px'/>
                      : it.label
                    }
                  </div>
                </div>
              )
            )
          }
        </div>
      </Collapse>
    </div>
  )
}

export default PluginNauta
